import type { DndLibrary } from '@library';
import { DNDModel } from '@models/dnd.model';
import BaseStore from '@stores/base/base.store';
import type RootStore from '@stores/root.store';
import type { DNDBlock, LoadedDndModel } from '@stratumn/studio-shared';

export class DNDStore extends BaseStore<DNDModel> {
  constructor(rootStore: RootStore) {
    super(rootStore, DNDModel, 'dnd');
  }

  createNewDndModel(
    library: DndLibrary,
    newDndModelId?: string,
    state?: DNDBlock<'root'>,
    loading?: boolean
  ): DNDModel {
    const newDndModel = new DNDModel(
      this,
      library,
      newDndModelId,
      state,
      loading
    );

    this.set(newDndModel.id, newDndModel);
    return newDndModel;
  }

  createDndFromLoaded(library: DndLibrary, loaded: LoadedDndModel): DNDModel {
    return this.createNewDndModel(library, loaded.id, loaded.state);
  }
}
